<template>
    <svg viewBox="0 0 24 24" :width="size" :height="size">
        <rect
            x="7"
            y="4"
            width="10"
            height="16"
            fill="none"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linejoin="round"
        />
        <line
            x1="7"
            y1="20"
            x2="17"
            y2="4"
            stroke="currentColor"
            stroke-width="1.2"
        />
        <line
            x1="7"
            y1="4"
            x2="17"
            y2="20"
            stroke="currentColor"
            stroke-width="1.2"
        />
    </svg>
</template>

<script setup lang="ts">
interface Props {
    size?: number | string
}

withDefaults(defineProps<Props>(), {
    size: 36,
})
</script>
